import { FC } from "react";
import { getStaticUrl, getUrlByContext } from "../../utils";
import { useConfiguration } from "../../hooks/useConfiguration";
import { MatchStatus } from "../../types/stats";
import { FileTextOutlined, PlayCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "../../components";

interface LinksProps {
    reportUrl?: string;
    videoUrl?: string;
    textLiveUrl?: string;
    reviewUrl?: string;
    matchStatus?: MatchStatus;
}

export const Links: FC<LinksProps> = ({
    reportUrl,
    videoUrl,
    textLiveUrl,
    reviewUrl,
    matchStatus = MatchStatus.UPCOMING,
}) => {
    const config = useConfiguration();

    if (!reportUrl && !videoUrl && !textLiveUrl && !reviewUrl) {
        return null;
    }

    const isLive = matchStatus === MatchStatus.IN_PROGRESS;
    const isUpcoming = matchStatus === MatchStatus.UPCOMING;

    let videoTitle = 'Запись';

    if (isLive) {
        videoTitle = 'Смотреть';
    } else if (isUpcoming) {
        videoTitle = 'Трансляция';
    }

    const linkClassNames = "border border-solid border-slate-200 text-slate-950 min-w-[50px] min-h-[50px] sm:min-h-unset sm:min-w-[140px] p-2 sm:px-3 text-xl sm:text-lg font-semibold flex rounded-full bg-white flex-row justify-center items-center gap-1 max-w-full box-border hover:bg-gray-300 hover:no-underline uppercase active:scale-95 transition-all";
    const labelClassNames = "hidden sm:block";
    return (
        <div className="box-border mx-auto">
            <div className="flex flex-row flex-wrap box-border mx-auto text-center items-center justify-center gap-2">
                {reportUrl && <Link to={getUrlByContext(reportUrl, config.teamName)} className={linkClassNames} rel="noreferrer">
                    <FileTextOutlined />
                    <span className={labelClassNames}>Отчет</span>
                </Link>}
                {videoUrl && <a href={videoUrl} className={linkClassNames} rel="noreferrer">
                    <PlayCircleOutlined />
                    <span className={labelClassNames}>{videoTitle}</span>
                </a>}
                {textLiveUrl && <a href={textLiveUrl} className={linkClassNames} rel="noreferrer noopener">
                    <img src={getStaticUrl("/static/images/match/text.png")} className="w-8 sm:w-6" alt="Текстовая трансляция" />
                    <span className={labelClassNames}>Текстовая</span>
                </a>}
                {reviewUrl && <a href={reviewUrl} className={linkClassNames} rel="noreferrer noopener">
                    <SearchOutlined />
                    <span className={labelClassNames}>Обзор</span>
                </a>}
            </div>
        </div>
    );
}